export const generateEcoErrorMessage = (error: string, isBomLocked: boolean): string => {
  const sapErrorMessage = error.split('§§§')[0];

  return isBomLocked
    ? `Maybe the ECO number was incorrect or no longer valid? Error from SAP: ${sapErrorMessage}`
    : sapErrorMessage;
};
